import { useTranslation } from 'translations/hooks';

import { RingButtons } from 'ui/quality-control/board/ring-buttons';
import { Segment } from 'ui/quality-control/board/segment';

import { BoardConfigurationData, BoardDisplayMode, RingData } from './types';

type RingProps = {
  data: RingData;
  boardConfiguration: BoardConfigurationData;
  boardPosition: number;
  isHighlighted: boolean;
  onSegmentMouseEnter?: (points: string) => void;
  onSegmentMouseLeave?: () => void;
  setSelectedRing?: (ringId: string) => void;
  canManageCompliance?: boolean;
};

export const Ring = ({
  data,
  boardConfiguration,
  boardPosition,
  isHighlighted,
  onSegmentMouseEnter,
  onSegmentMouseLeave,
  setSelectedRing,
  canManageCompliance,
}: RingProps) => {
  const { t } = useTranslation();

  const posX = boardConfiguration.padding.left;
  const posY =
    boardConfiguration.padding.top +
    boardPosition * boardConfiguration.segment.height;
  // use the position of the ring to display the ring at the right place

  const marginYText = boardConfiguration.segment.height / 2;

  return (
    <>
      {[BoardDisplayMode.Complete, BoardDisplayMode.Preview].includes(
        boardConfiguration.board.displayMode,
      ) ? (
        <g>
          {/* display 2 lines on the left side of the board */}
          {data.label ? (
            <>
              <text x={posX} y={marginYText + posY} fontSize="12">
                {data.label}
              </text>
              {data.hasKeyPosition ? (
                <text x={posX} y={marginYText + posY + 12} fontSize="12">
                  {data.type}
                </text>
              ) : null}
            </>
          ) : (
            <text x={posX} y={marginYText + posY + 5} fontSize="12">
              {data.type}
            </text>
          )}
        </g>
      ) : null}
      {!data.hasKeyPosition ? (
        <text
          x={
            boardConfiguration.margin.left +
            boardConfiguration.margin.leftInsideBoard
          }
          y={marginYText + posY}
          fontSize="11"
          fill="#888888"
          dominantBaseline="middle"
          fontStyle="italic"
        >
          {t('qualityControl.recordSegmentDefect.board.ringNoKeyPosition', {
            ringNumber: parseInt(data.label ?? '0', 10),
          })}
        </text>
      ) : null}
      {data.hasKeyPosition &&
        data.segments.map((segment, index) => {
          // default position of the segment, left margin + position in the ring
          let segmentPosX =
            boardConfiguration.margin.leftInsideBoard +
            data.marginX +
            index * boardConfiguration.segment.width;

          // in order to not go outside the board we calculate the new position
          // a right margin is added in order to not have segment truncated
          if (
            segmentPosX + boardConfiguration.segment.width >
            boardConfiguration.ringBoardWidth -
              boardConfiguration.margin.rightInsideBoard
          ) {
            segmentPosX =
              segmentPosX -
              data.segments.length * boardConfiguration.segment.width;
          }

          return (
            <Segment
              key={segment.key}
              data={segment}
              boardConfiguration={boardConfiguration}
              posX={boardConfiguration.margin.left + segmentPosX} // add a margin on the left side and use position of each segments
              posY={posY}
              isHighlighted={isHighlighted}
              onSegmentMouseEnter={onSegmentMouseEnter}
              onSegmentMouseLeave={onSegmentMouseLeave}
            />
          );
        })}

      {boardConfiguration.board.displayMode === BoardDisplayMode.Complete &&
      data.hasKeyPosition ? (
        <RingButtons
          data={data}
          boardConfiguration={boardConfiguration}
          posY={posY}
          setSelectedRing={setSelectedRing}
          canManageCompliance={canManageCompliance}
        />
      ) : null}
    </>
  );
};
